module.exports = "/_next/static/images/seo-image-2x-ef42d118111c96154c5120e86cab9596.png.webp";